import logo from './data/logoch.png';
import logoa from './data/logoa.png';
import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Llogout } from './config';
import { LogOutIcon, UserPlusIcon, Layers2Icon , MapPinPlus, PackagePlusIcon, BookPlusIcon, PaperclipIcon, ListPlusIcon, DeleteIcon, ImagePlusIcon  } from 'lucide-react';
import lr from 'lucide-react'
import PoiTable from './poitable';

import './poitable.css';
export default function MAdmin() {
    
    const navigate = useNavigate();
    const [bearer, setBea] = useState(null);
return (
   <table>
            
            <tr>
                <th>Luoghi</th>
                <th>Object</th>
                <th>Generali</th>
            </tr>
            <tr>
              <td>
                <button onClick={() => navigate("/newcity", { bearer: { bearer } })}>
                  <MapPinPlus className="mr-2" /><br/>Nuovo luogo
                </button><br/>
                
              </td>
              <td>
                <button onClick={() => navigate("/newbimobj", { bearer: { bearer } })}>
                <PackagePlusIcon className="mr-2" /><br/>
                  Nuovo Oggetto
                </button>
              </td>
              <td>
                <button onClick={() => navigate("/newuser", { bearer: { bearer } })}>
                  <UserPlusIcon className="mr-2" /><br/>Nuovo utente
                  
                </button>
            </td>
            </tr>
            <tr>
              <td>
                <button onClick={() => navigate("/addlayer", { bearer: { bearer } })}>
                  <Layers2Icon className="mr-2" /><br/>Aggiungi layer a luogo
                </button>
              </td>

               <td>
              <button onClick={() => navigate("/addinfo")}>
                <BookPlusIcon className="mr-2" /><br/>
                Aggiungi Caratteristica
              </button>
              </td>
               <td>
              <button onClick={function aa() {
                    Llogout();
                    navigate("/landingpage")
              }}>
                <LogOutIcon className="mr-2" /><br/>Logout
              </button>
              </td>
              </tr>
              <tr>
               <td><button onClick={() => navigate("/addimg", { bearer: { bearer } })}>
                <ImagePlusIcon className="mr-2" /> <br/>
                  Aggiungi immagine
                </button></td> 
               <td>  <button onClick={() => navigate("/addall")}>
                <PaperclipIcon className="mr-2" /><br/>Aggiungi allegato
              </button></td>
              <td>
                 <button onClick={() => navigate("/delete")}>
                <DeleteIcon className="mr-2" /><br/>Cancella ....</button>
              </td>
            </tr>
            <tr>
                <td>
                </td>
                <td><button onClick={() => navigate("/addval")}>
                <ListPlusIcon className="mr-2" /><br/>Aggiungi Misurazione
              </button></td>
                <td></td>
                </tr>
                <tr>
                <th colSpan={"3"}>
                  <img width="400" src={require(`./assets/objger.png`)}/><br/>
                  <button onClick={() => navigate("/poitable", { bearer: { bearer } })}>
                    tabella completa dei contenuti                  
                </button><br/>
                </th>
                
            </tr>
          </table>
          
)
}